import { render, staticRenderFns } from "./SPUEditor.vue?vue&type=template&id=08f0f1ee&scoped=true"
import script from "./SPUEditor.vue?vue&type=script&lang=ts"
export * from "./SPUEditor.vue?vue&type=script&lang=ts"
import style0 from "./SPUEditor.vue?vue&type=style&index=0&id=08f0f1ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f0f1ee",
  null
  
)

export default component.exports